import { Component, Input } from '@builder.io/sdk';

import { buttonFields } from 'molecules/Button/config';
import { moleculeHeadingFields } from 'molecules/Heading/config';
import imageField from 'molecules/Image/config';
import sectionFields from 'molecules/Section/config';
import videoField from 'molecules/VideoCustom/config';

import { idField } from 'utils/builder/fields';

const slideFields = [
  idField,
  {
    name: 'title',
    type: 'string',
    helperText: 'Heading text for this slide.',
  },
  {
    name: 'description',
    type: 'richText',
    helperText: 'Optional supporting text for the slide. Can include formatting and links.',
  },
  {
    name: 'mediaType',
    type: 'string',
    enum: ['image', 'video'],
    defaultValue: 'image',
    helperText: 'Choose the media type to display for this slide.',
  },
  imageField('image', "options.get('mediaType') !== 'video'"),
  {
    name: 'video',
    type: 'object',
    subFields: videoField.inputs,
    showIf: "options.get('mediaType') === 'video'",
    helperText: 'Video settings (URL and thumbnail).',
  },
  {
    name: 'button',
    type: 'object',
    subFields: buttonFields,
    helperText: 'Configure the button label, URL, and style for this slide.',
  },
] as const satisfies DeepReadonly<Input[]>;

const slideboxFields = [
  ...moleculeHeadingFields,
  ...sectionFields,
  {
    name: 'slides',
    type: 'list',
    subFields: slideFields,
    helperText: 'Add up to 3 slides. Each slide can include a title, description, image or video, and button.',
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onChange: (options: Map<string, any>) => {
      if (options.get('slides').length > 3) {
        options.set('slides', options.get('slides').slice(0, 3));
        alert('Maximum slide count is 3. Removing excess slides.');
      }
    },
  },
  ...sectionFields,
] as const satisfies DeepReadonly<Input[]>;

const slideboxConfig = {
  name: 'slidebox',
  inputs: slideboxFields,
} as Component;

export type SlideConfigProps = GenerateBuilder<typeof slideFields>;
export type SlideboxConfigProps = GenerateBuilder<typeof slideboxFields>;

export default slideboxConfig;
